import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
class ColorAndHover extends Component {
    static propTypes = {
        tagNameName: PropTypes.string
    };
    static contextTypes = {
        store: PropTypes.object
    };

    render() {
        const isDisabled = this.props.themeAccess || this.props.isDisabled;

        return (
            <div className="ColorAndHover">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-3">
                        {this.props.colorLabel}
                        <PresetColorPicker
                            color={this.props.text.color}
                            isDisabled={isDisabled}
                            onColorChange={this.props.onThemePropChange('gallery.text.color')}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        {this.props.hoverLabel}
                        <BackgroundPicker
                            background={this.props.text.background}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={isDisabled}
                            onChange={property =>
                                this.props.onThemePropChange('gallery.text.background')({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.carousel[ownProps.tagName],
        ...state.theme.carousel,
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onThemePropChange: onThemePropChange(dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorAndHover);



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/ColorAndHover.js